import { createContext } from "react";

export const ProductGroup = createContext()